<template>
  <div class="mt-9 mt-md-0 fill-height d-flex flex-column wrap">
    <div
      class="d-flex justify-space-between font-weight-bold mb-4 align-center"
    >
      <span class="font-weight-bold title">Species</span>
      <router-link
        v-if="!currentUser.isTourist()"
        :to="{ name: 'species' }"
        class="font-weight-bold title sm"
      >
        All Species
        <v-icon color="primary" size="16px">$arrowRight</v-icon>
      </router-link>
    </div>
    <v-card
      class="card-tab overflow-hidden d-flex flex-column wrap justify-space-between flex-2"
      min-height="376"
    >
      <div class="card-header elevation-1">
        <v-tabs v-model="tab" background-color="white" grow>
          <v-tab
            v-for="(species, key, index) in species"
            :key="index"
            class="font-weight-bold subtitle-1 border-none"
            :class="`${key}-tab`"
          >
            {{ key.capitalize() }}
          </v-tab>
        </v-tabs>
      </div>
      <div
        class="card-body pa-5 flex-2"
        :class="
          !species.thriving.length || !species.thriving.length
            ? 'd-flex justify-center align-center'
            : ''
        "
      >
        <v-tabs-items v-model="tab" class="mt-1">
          <v-tab-item v-for="(species, key, index) in species" :key="index">
            <v-skeleton-loader
              v-if="fetching[key] && species.length < 1"
              min-height="200"
              type="list-item-avatar@3"
            />
            <div
              v-if="!species.length"
              class="font-weight-bold text--secondary"
            >
              Not Enough Data!
            </div>
            <v-card flat v-for="(species, index) in species" :key="index">
              <div class="d-flex align-center mb-3">
                <v-avatar tile size="64px">
                  <v-img
                    :src="getMedia(species)"
                    :alt="species.name"
                    lazy-src="/placeholder.jpg"
                  />
                </v-avatar>
                <v-list-item color="primary" class="pl-5">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold body-2 mb-3">
                      {{ species.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="green--text">
                      {{ species.sighting_chance }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action style="display: none;">
                    <router-link
                      :to="{
                        name: 'species',
                        query: { action: 'stats', species_id: species.id },
                      }"
                      class="primary--text font-weight-bold"
                    >
                      Full Statistics
                    </router-link>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <v-card-actions
        class="px-5 pt-3 text-center justify-center justify-md-space-between d-flex"
      >
        <v-chip
          v-for="(range, index) in range"
          :key="index"
          class="px-7 px-md-4 mx-2"
          :color="selectedRange === range ? 'primary' : 'grey lighten-4'"
          @click="report(range)"
        >
          {{ range.capitalize() }}
        </v-chip>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Species from '@models/Species';
export default {
  name: 'SpeciesTabList',
  data() {
    return {
      species: {
        thriving: [],
        endangered: [],
      },
      fetching: {
        thriving: false,
        endangered: false,
      },
      range: ['day', 'week', 'month'],
      selectedRange: 'day',
      tab: 0,
    };
  },
  methods: {
    async fetchThriving(from = $moment(), to = $moment()) {
      this.fetching.thriving = true;
      this.species.thriving = [];
      let response = await new Species({
        itemsPerPage: 3,
        sortDesc: [true],
        filters: {
          user_id: this.$store.state.auth.user.isTourismOperator()
            ? this.$store.state.auth.user.id
            : null,
          sighting_from: from.format('YYYY-MM-DD'),
          sighting_to: to.format('YYYY-MM-DD'),
        },
        sortBy: ['thriving'],
      }).get();
      if (response) {
        this.species.thriving = response.data;
      }
      this.fetching.thriving = false;
    },
    async fetchEndangered(from = $moment(), to = $moment()) {
      this.fetching.endangered = true;
      this.species.endangered = [];
      let response = await new Species({
        itemsPerPage: 3,
        sortDesc: [false],
        filters: {
          user_id: this.$store.state.auth.user.isTourismOperator()
            ? this.$store.state.auth.user.id
            : null,
          sighting_from: from.format('YYYY-MM-DD'),
          sighting_to: to.format('YYYY-MM-DD'),
        },
        sortBy: ['endangered'],
      }).get();
      if (response) {
        this.species.endangered = response.data;
      }
      this.fetching.endangered = false;
    },
    report(range) {
      this.selectedRange = range;
      if (range === 'month') {
        this.reportMonthly();
      } else if (range === 'week') {
        this.reportWeekly();
      } else {
        this.fetchThriving();
        this.fetchEndangered();
      }
    },
    reportWeekly() {
      let from = $moment().weekday(0);
      this.fetchThriving(from);
      this.fetchEndangered(from);
    },
    reportMonthly() {
      let from = $moment().startOf('month');
      this.fetchThriving(from);
      this.fetchEndangered(from);
    },
  },
  async mounted() {
    await this.fetchThriving();
    this.fetchEndangered();
  },
};
</script>
